//@flow
import React, { useEffect, useState } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { InfoLinks } from 'components/molecules/infoLinks';
import OurDifferencePageContent from 'components/molecules/ourDifferencePageContent';
import { OverlayModal } from 'components/templates/overlayModal';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { HTMLView } from 'components/atoms/htmlView';
import { Image } from 'components/atoms/image';
import { useViewport } from 'components/templates/viewportProvider';
//eslint-disable-next-line
import styles from "./style.scss";

type dataProps = {
  id: number,
  tag_word: string,
  image: string,
  mobile_image: string,
  thumbnail: string,
  page_title: string,
  parent_page_title: string,
  short_content: Object,
  long_content: Object,
  cms_page_id: number,
  media_path: string,
  media_path_mobile: string,
};

type infoLinksProps = {
  data: Array<dataProps>,
  title: string,
  link: string,
  id: number,
  cms_page_id: number,
};

type cmsDetailsDataProps = {
  id: number,
  page_title: string,
  cms_detail_page_contents: Object,
  media_path: string,
  thumbnail: string,
  mobile: string,
  web: string,
};

type Props = {
  our_difference_description: string,
  our_difference_heading: string,
  infoLinks: Array<infoLinksProps>,
  cmsDetailsData: Object<cmsDetailsDataProps>,
  heading_classname: string,
};

const OurDifferenceLanding = (props: Props) => {
  const {
    our_difference_heading,
    our_difference_description,
    infoLinks,
    cmsDetailsData,
    heading_classname,
    breadcrumbList,
  } = props;
  const { height } = useViewport();

  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [selected_link_id, set_selected_link_id] = useState(0);
  const [selected_link_name, set_selected_link_name] = useState(' ');
  const [overlay_page_data, set_overlay_page_data] = useState({});
  const [show_overlay_button, set_show_overlay_button] = useState(false);
  const media_path = infoLinks.length > 0 && infoLinks[0].data.media_path;
  const short_content =
    infoLinks.length > 0 && infoLinks[selected_link_id].data.short_content;
  let long_content =
    infoLinks.length > 0 && infoLinks[selected_link_id].data.long_content;

  useEffect(() => {
    if (cmsDetailsData) {
      checkOverlayCorrespondingFeature(selected_link_id, selected_link_name);
    }
  }, [selected_link_id]);

  const checkOverlayCorrespondingFeature = (selected_id, selected_name) => {
    let data = {};
    set_overlay_page_data(data);
    set_show_overlay_button(false);
    Object.values(cmsDetailsData).map((data, idx) => {
      if (infoLinks[selected_id].cms_page_id === data.cms_page_id) {
        set_overlay_page_data(data);
        set_show_overlay_button(true);
        return;
      }
    });
  };

  const handleInfoClick = (id, link_name) => {
    set_selected_link_id(id);
    set_selected_link_name(link_name);
  };

  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'ourDifference'}
        className={'ourHomesOverlay'}
        mediaPath={media_path}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: breadcrumbList[1].breadcrumbName,
            breadcrumbLink: breadcrumbList[1].breadcrumbLink,
          },
          {
            breadcrumbName: breadcrumbList[2].breadcrumbName,
            breadcrumbLink: breadcrumbList[2].breadcrumbLink,
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className="our-difference-body section-container" style={{ height }}>
      <Row className="top-row">
        <Col className={'content-col'} md={{ span: 4 }}>
          <h1 className={heading_classname}>{our_difference_heading}</h1>
          <HTMLView
            tagName={'p'}
            html={our_difference_description}
            className={'our-difference-description'}
          />
        </Col>
        <Col className={'image-col'} md={{ span: 8 }}>
          <Image
            className={'feature-img'}
            src={`${infoLinks[selected_link_id].data.image}`}
            thumbNail={`${infoLinks[selected_link_id].data.thumbnail}`}
            alt="img"
            isHoveredImagePresent={true}
          />
        </Col>
      </Row>
      <Row className="bottom-row">
        <Col md={{ span: 4 }}>
          <div className="our-difference-features">
            <InfoLinks
              links={infoLinks}
              selectedLinkId={selected_link_id}
              selected_link={(id, link_name) => {
                handleInfoClick(id, link_name);
              }}
              connectRoute={false}
            />
          </div>
        </Col>
        <Col md={{ span: 8 }}>
          <h3 className={'selected-feature'}>
            {selected_link_name === ' '
              ? infoLinks[0].title
              : selected_link_name}
          </h3>
          {infoLinks[selected_link_id].data.tag_word && (
            <span className="features-desription">
              {infoLinks[selected_link_id].data.tag_word}
            </span>
          )}
          <OurDifferencePageContent
            short_content={short_content}
            long_content={long_content}
            renderOverlayButton={show_overlay_button}
            onClick={e => setshowDescriptionLayout(true)}
          />
        </Col>
      </Row>
      {showOverlay}
    </div>
  );
};
export default OurDifferenceLanding;
